import { createContext, useCallback, useContext, useState } from 'react'
import { connect as walletConnect, disconnect as walletDisconnect, StarknetWindowObject } from 'get-starknet'
import { networkNameByChainId } from '../services/wallet.service'
import { CairoVersion, shortString } from 'starknet'
import semver from 'semver'
import BigNumber from 'bignumber.js'
import { getStorageWallet } from '../utils'
import { getProvider } from '../services/amm'

interface IWalletContext {
    networkName?: string | undefined
    walletAddress?: string | undefined
    cairoVersion?: CairoVersion | undefined
    isMultisig?: boolean | undefined
    connect: (silent?: boolean) => Promise<boolean>
    disconnect: () => void
}

const walletContextDefault: IWalletContext = {
    connect: async () => false,
    disconnect: () => {}
}

const WalletContext = createContext<IWalletContext>(walletContextDefault)

async function getAccountMultisig(wallet: undefined | StarknetWindowObject): Promise<boolean> {
    if (!wallet?.selectedAddress || !wallet?.id.toLowerCase().includes('braavos')) {
        return Promise.resolve(false)
    }

    try {
        const provider = await getProvider(networkNameByChainId(wallet?.account?.chainId || wallet?.account?.provider?.chainId))
        const isMultisig = await provider
            // const isMultisig = await (wallet.provider as Provider)
            .callContract({
                contractAddress: wallet.selectedAddress,
                entrypoint: 'get_multisig'
            })
            .then((res) => new BigNumber(res.result[0]).toNumber())

        return isMultisig > 0
    } catch {}
    return false
}

export default function WalletContextProvider({ children }: any) {
    const [data, setData] = useState<IWalletContext>(walletContextDefault)
    // const [isConnected, setIsConnected] = useState(false)

    const handleAccountChanged = useCallback(async () => {
        const wallet: StarknetWindowObject | undefined = window.getStarknet?.()
        // if (wallet && wallet.selectedAddress) {
        //     setIsConnected(true)
        // } else {
        //     setIsConnected(false)
        // }

        const cairoVersion = await getAccountCairoVersion(wallet)
        const isMultisig = await getAccountMultisig(wallet)

        if (wallet) {
            // @ts-ignore
            wallet.cairoVersion = cairoVersion
            // @ts-ignore
            wallet.isMultisig = isMultisig
        }

        // console.log('wallet?.selectedAddress ', wallet?.selectedAddress, cairoVersion, isMultisig)

        // @ts-ignore
        // console.log('wallet?.account? ', wallet?.account?.chainId || wallet?.account?.provider?.chainId)
        // console.log('wallet?.account?.chainId ', wallet?.account?.chainId)
        const storageWallet = getStorageWallet()
        setData((data) => ({
            ...data,
            walletAddress: storageWallet ? storageWallet : wallet?.selectedAddress,
            cairoVersion,
            isMultisig,
            // @ts-ignore
            networkName: networkNameByChainId(wallet?.account?.chainId || wallet?.account?.provider?.chainId)
        }))
    }, [])

    async function connect(silent?: boolean) {
        const isDisconnected = window.localStorage.getItem('isDisconnected') === 'true'
        return walletConnect({
            // modalMode: 'alwaysAsk',
            modalMode: isDisconnected ? 'alwaysAsk' : 'canAsk',
            // modalMode: silent ? 'neverAsk' : 'canAsk',
            modalTheme: 'dark',
            sort: ['braavos']
        }).then((wallet) => {
            window.getStarknet = () => wallet ?? undefined
            return (
                wallet?.enable({ starknetVersion: 'v5' }).then((accounts) => {
                    wallet.on('accountsChanged', handleAccountChanged)
                    window.localStorage.setItem('isDisconnected', 'false')
                    // window.localStorage.setItem('connectedWithWallet', 'true')
                    handleAccountChanged()
                    return !!accounts
                }) ?? false
            )
        })
    }

    // const connect = useCallback(
    //     async (silent?: boolean) =>
    //         walletConnect({
    //             modalMode: 'alwaysAsk',
    //             modalTheme: 'dark',
    //             sort: ['braavos']
    //         }).then((wallet) => {
    //             window.getStarknet = () => wallet ?? undefined
    //             return (
    //                 wallet?.enable({ starknetVersion: 'v5' }).then((accounts) => {
    //                     wallet.on('accountsChanged', handleAccountChanged)
    //                     handleAccountChanged()
    //                     return !!accounts
    //                 }) ?? false
    //             )
    //         }),
    //     []
    // )

    const disconnect = useCallback(() => {
        window.getStarknet?.()?.off('accountsChanged', handleAccountChanged)
        walletDisconnect().catch((err) => console.error(err))
        setData((data) => ({
            ...data,
            walletAddress: undefined,
            cairoVersion: undefined,
            isMultisig: undefined,
            networkName: undefined
        }))
    }, [handleAccountChanged])

    return <WalletContext.Provider value={{ ...data, connect, disconnect }}>{children}</WalletContext.Provider>
}

export function useWalletContext(): IWalletContext {
    return useContext(WalletContext)
}

const getAccountCairoVersion = async (wallet: undefined | StarknetWindowObject): Promise<CairoVersion | undefined> => {
    try {
        if (!wallet?.selectedAddress) {
            return undefined
        }

        if (wallet.id.toLowerCase().includes('braavos')) {
            try {
                const provider = await getProvider(networkNameByChainId(wallet?.account?.chainId || wallet?.account?.provider?.chainId))

                const implVersion = await provider.callContract({
                    contractAddress: wallet.selectedAddress,
                    entrypoint: 'get_impl_version'
                })
                console.log('YSYSYS we are cairo 0')
                return '0' // if exists we are cairo 0
            } catch {}
            console.log('YSYSYS we are cairo 1')

            return '1'
        }

        if (!wallet.id.toLowerCase().includes('argent')) {
            return '0'
        }

        const provider = await getProvider(networkNameByChainId(wallet?.account?.chainId || wallet?.account?.provider?.chainId))

        const encodedString = await provider
            .callContract({
                contractAddress: wallet.selectedAddress,
                entrypoint: 'getVersion'
            })
            .then((res) => res.result[0])
        const accountContractVersion = shortString.decodeShortString(encodedString)

        return semver.gte(accountContractVersion, '0.3.0') ? '1' : '0'
    } catch (e) {
        return undefined
    }
}
